import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { PDFViewer } from '@/shared/components/ui/PDF';
import type { IDocumentoItem } from '@/shared/interfaces/erp/tickets-soporte-clientes';
import { esImagen } from './documentos.constants';

interface VisorDocumentoDialogProps {
  documento: IDocumentoItem | null;
  /** Permiso vision360.descargar_documentos. */
  puedeDescargar: boolean;
  onClose: () => void;
}

// Basado en VerPdfModal (firma-adendum), que no se reutiliza porque exige
// noTramite y tiene textos fijos de "PDF firmado". Las URLs son publicas, asi
// que ocultar la descarga es solo de UI, no un control de seguridad.
export default function VisorDocumentoDialog({ documento, puedeDescargar, onClose }: VisorDocumentoDialogProps) {
  return (
    <Dialog open={!!documento} onClose={onClose} fullWidth maxWidth="md" PaperProps={{ sx: { height: '85vh' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="h6" noWrap>
          {documento?.nombre}
        </Typography>
        <IconButton aria-label="Cerrar" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, display: 'flex', flexDirection: 'column', bgcolor: 'grey.100' }}>
        {documento && esImagen(documento.url) && (
          <Box
            component="img"
            src={documento.url}
            alt={documento.nombre}
            sx={{ m: 'auto', maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
          />
        )}
        {documento && !esImagen(documento.url) && (
          <PDFViewer fileUrl={documento.url} title={documento.nombre} allowDownload={puedeDescargar} />
        )}
      </DialogContent>
      <DialogActions>
        {puedeDescargar && (
          // Dominio externo: el atributo download se ignora, se abre en otra pestaña.
          <Button
            variant="outlined"
            startIcon={<DownloadOutlinedIcon />}
            component="a"
            href={documento?.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar
          </Button>
        )}
        <Button variant="contained" onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
